var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("vue-content-loading", { attrs: { width: 400, height: 10 } }, [
    _c("rect", {
      attrs: {
        rx: "1",
        height: "6.11111",
        width: "46.94441",
        y: "2.15365",
        x: "0.97235",
      },
    }),
    _vm._v(" "),
    _c("rect", {
      attrs: {
        rx: "50",
        height: "6.11111",
        width: "6",
        y: "2.15365",
        x: "50.69454",
      },
    }),
    _vm._v(" "),
    _c("rect", {
      attrs: {
        rx: "1",
        height: "4",
        width: "13.88888",
        y: "3.2092",
        x: "273.47217",
      },
    }),
    _vm._v(" "),
    _c("rect", {
      attrs: {
        rx: "1",
        height: "4",
        width: "13.88888",
        y: "3.2092",
        x: "290.4166",
      },
    }),
    _vm._v(" "),
    _c("rect", {
      attrs: {
        rx: "1",
        height: "6.11111",
        width: "49.44441",
        y: "2.15365",
        x: "309.30549",
      },
    }),
    _vm._v(" "),
    _c("rect", {
      attrs: {
        rx: "1",
        height: "6.11111",
        width: "13.88888",
        y: "2.15365",
        x: "366.24988",
      },
    }),
    _vm._v(" "),
    _c("rect", {
      attrs: {
        rx: "1",
        height: "6.11111",
        width: "13.88888",
        y: "2.15365",
        x: "384.30543",
      },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }